import { formatDisplayName } from '../../p2p/displayName.js';
import {
  challengeJoinUrl,
  formatChallengeDeadline,
  formatChallengeLabel,
  formatCountdown,
  formatStartCommitment
} from '../../p2p/challenges.js';
import { getPlayerProfile } from '../../p2p/playerProfiles.js';

function challengerLabel(challenge) {
  const profile = getPlayerProfile(challenge.challenger.playerId);
  if (profile?.nickname) {
    return formatDisplayName(profile.nickname, challenge.challenger.playerId);
  }
  if (challenge.challenger.nickname) {
    return formatDisplayName(challenge.challenger.nickname, challenge.challenger.playerId);
  }
  return challenge.challenger.playerId;
}

export default function IncomingChallengeModal({
  challenges = [],
  onAccept,
  onDecline,
  onBlockPlayer,
  onBlockAllChallenges,
  onReviewInAccount
}) {
  if (!challenges.length) {
    return null;
  }

  const challenge = challenges[0];
  const label = formatChallengeLabel({
    timeControl: challenge.timeControl,
    variant: challenge.variant,
    rated: challenge.rated
  });
  const schedule = formatStartCommitment(challenge);
  const acceptRemaining = challenge.expiresAt - Date.now();
  const name = challengerLabel(challenge);
  const acceptHref = challengeJoinUrl(challenge);

  return (
    <div className="modal-backdrop challenge-modal-backdrop">
      <div
        className="modal-dialog challenge-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="incoming-challenge-title"
      >
        <p className="eyebrow">Incoming challenge</p>
        <h2 id="incoming-challenge-title">{name} challenged you</h2>
        <p className="challenge-modal-lede">
          <strong>{label}</strong>
          {challenges.length > 1
            ? ` · ${challenges.length} challenges waiting`
            : null}
        </p>
        <p className="muted">
          {challenge.rated
            ? 'This would be a proof-backed Rated ladder game.'
            : 'This would be an Unrated casual game.'}
        </p>
        {schedule && <p className="muted">{schedule}</p>}
        {challenge.expiresAt && acceptRemaining > 0 && (
          <p className="muted">
            Accept by {formatChallengeDeadline(challenge.expiresAt)}
            {' '}
            ({formatCountdown(acceptRemaining)} left)
          </p>
        )}
        <p className="muted">
          Accepting opens their board. You can decline if you are busy.
        </p>
        <p className="challenge-modal-link-row">
          <a
            className="challenge-accept-link"
            href={acceptHref}
            onClick={(event) => {
              event.preventDefault();
              onAccept?.(challenge);
            }}
          >
            Open accept link
          </a>
          <span className="muted"> · join their game directly</span>
        </p>

        <div className="challenge-modal-actions">
          <button
            type="button"
            className="large-cta"
            onClick={() => onAccept?.(challenge)}
          >
            Accept challenge
          </button>
          <button
            type="button"
            className="text-button"
            onClick={() => onDecline?.(challenge)}
          >
            Decline
          </button>
          {onReviewInAccount && (
            <button
              type="button"
              className="text-button"
              onClick={() => onReviewInAccount?.(challenge)}
            >
              Review in Account & network
            </button>
          )}
          {onBlockPlayer && (
            <button
              type="button"
              className="text-button"
              onClick={() => onBlockPlayer?.(challenge)}
            >
              Block this player
            </button>
          )}
        </div>

        {onBlockAllChallenges && (
          <p className="challenge-modal-block">
            <button
              type="button"
              className="text-button"
              onClick={onBlockAllChallenges}
            >
              Block all challenges
            </button>
            <span className="muted"> to stop invites and avoid spam.</span>
          </p>
        )}
      </div>
    </div>
  );
}
